<template>
	<div class="page-traveler page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="12">
					<h3 style="float: none;">出差人员信息</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置:</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>出差人员</el-breadcrumb-item>
							<el-breadcrumb-item>出差人员信息</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="table-block content-body">
					<div ref="contentBody">
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
							<el-table-column prop="name" align="center" label="姓名" min-width="120"></el-table-column>
							<el-table-column prop="type" align="center" label="人员类型" min-width="120"></el-table-column>
<!--							<el-table-column prop="company" align="center" label="公司" min-width="160"></el-table-column>-->
							<el-table-column prop="orgName" align="center" label="单位/部门" min-width="160"></el-table-column>
							<el-table-column prop="startDate" align="center" label="出差开始日期" min-width="140"></el-table-column>
							<el-table-column prop="endDate" align="center" label="出差结束日期" min-width="140"></el-table-column>
							<el-table-column prop="createdate" align="center" label="创建时间" min-width="160"></el-table-column>
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="table_data.page_info.page" :page-sizes="[10,30,50,80,100]" :page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next" :total="table_data.page_info.total"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'travelerList',
	data() {
		return {
			body_loading: false,
			table_data: {
				loading: false,
				list: [],
				page_info: {
					page: 1,
					pageSize: 10,
					total: 0
				}
			}
		}
	},
	created() {
		document.title = '出差人员信息';
		this.getList();
	},
	methods: {
		getList() {
			var _this = this;
			var params = {
				pageNo: _this.table_data.page_info.page,
				pageSize: _this.table_data.page_info.pageSize
			};
			_this.table_data.loading = true;
			this.$client.get('/api/biz/business/traveler/getListForAdmin', params, function(res, message, total) {
				_this.table_data.list = res;
				_this.table_data.page_info.total = total;
				_this.table_data.loading = false;
			}, function(res) {
				_this.table_data.loading = false;
			});
		},
		handleSizeChange(val) {
			this.table_data.page_info.pageSize = val;
			this.getList();
		},
		handleCurrentChange(val) {
			this.table_data.page_info.page = val;
			this.getList();
		}
	}
}
</script>
<style scoped>
</style>
